// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"663f40c3","614":"0afa0ecb","982":"f65be896"}[chunkId] + ".chunk.css";
};